import React from 'react';
import { popupListPropTypes } from './PopupListPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './PopupList.module.scss';
const PopupList = ({
  heading,
  items
}) => {
  if (!heading || !items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    classname: styles.rootClose
  })), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading, " "), items && /*#__PURE__*/React.createElement("ol", {
    className: styles.rootList
  }, items.map((el, index) => /*#__PURE__*/React.createElement("li", {
    className: styles.rootListItem,
    key: index
  }, el))));
};
export default PopupList;